module.exports = __webpack_public_path__ + "static/media/ticket-disabled.c7a0ea8c.svg";